// import axios from "axios";


var addCustomerRequest = (params) => axios._post(`/customer/add`, params); //添加客户需求信息
export {
  addCustomerRequest,
}



// WEBPACK FOOTER //
// ./src/service/service.js